import { getTableName, getTableColumns } from "drizzle-orm";
import type { PgTable, AnyPgColumn } from "drizzle-orm/pg-core";
import { getTableConfig } from "drizzle-orm/pg-core";
import { getOwnerRlsMeta, registerOwnerRls } from "./rls.js";

export interface OwnerMetaResolved {
  column: AnyPgColumn;
  columnName: string;
  propertyName: string;
  readPublic: boolean;
}

function resolvePropertyName(table: PgTable, columnName: string): string {
  try {
    const columns = getTableColumns(table);
    for (const [propName, col] of Object.entries(columns)) {
      if ((col as any).name === columnName) return propName;
    }
  } catch {
    /* tests */
  }
  return columnName;
}

export function detectOwnerMeta(table: PgTable): OwnerMetaResolved | null {
  const anyTable = table as any;
  const meta = getOwnerRlsMeta(table);
  if (meta) {
    const propName = resolvePropertyName(table, meta.columnName);
    const col = anyTable[propName] as AnyPgColumn | undefined;
    if (col) {
      return {
        column: col,
        columnName: meta.columnName,
        propertyName: propName,
        readPublic: meta.readPublic,
      };
    }
  }

  try {
    const config = getTableConfig(table);
    if (config.policies && config.policies.length > 0) {
      const propName = anyTable["userId"] ? "userId" : anyTable["user_id"] ? "user_id" : null;
      if (propName) {
        const userIdCol = anyTable[propName] as AnyPgColumn;
        const colName = (userIdCol as any).name || "user_id";
        registerOwnerRls(table, { columnName: colName, readPublic: false });
        return { column: userIdCol, columnName: colName, propertyName: propName, readPublic: false };
      }
      const tblName = getTableName(table);
      console.warn(
        `[createCrud] Table "${tblName}" has ${config.policies.length} pgPolicy but no userId/user_id column found.`,
      );
    }
  } catch {}

  return null;
}
